/*! Inspired by https://github.com/lindsayevans/outline.js/ */
(function (d) {
    'use strict';

    let style_element = d.createElement("STYLE");
    d.getElementsByTagName("HEAD")[0].appendChild(style_element);

    // Using mousedown instead of mouseover, so that previously focused elements don't lose focus ring on mouse move
    d.addEventListener("mousedown", function () {
        style_element.innerHTML =
            ":focus{outline:0}::-moz-focus-inner{border:0;}";
    });

    d.addEventListener("keydown", function () {
        style_element.innerHTML = "";
    });
})(document);
